import cn from 'classnames';
import Button from './components/Button/Button.css';
import MonthWrapper from './components/SearchForm/MonthWrapper/MonthWrapper.css';
import SearchFormDatepicker from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import Results from './components/Results/Results.css';
import WeekCalendar from './components/WeekCalendar/WeekCalendar.css';
import SearchForm from './components/SearchForm/SearchForm.css';
import LocationAutocomplete from './components/LocationAutocomplete/LocationAutocomplete.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import SeatStyles from './components/SeatMap/SeatMap';
import SocialAuth from './components/SocialAuth/SocialAuth.css';
import SegmentTab from './components/SegmentTab/SegmentTab.css';
import Counter from './components/Counter/Counter.css';
import Meal from './components/Meal/Meal.css';
import Segment from './components/DesktopFlightRoute/Segment/Segment.css';
import Point from './components/DesktopFlightRoute/Segment/Point/Point.css';
import RouteArrow from './components/DesktopFlightRoute/Segment/RouteArrow/RouteArrow.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import FlightPrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import StopsInfo from './components/DesktopFlightRoute/Segment/StopsInfo/StopsInfo.css';
import Amenities from './components/Amenities/Amenities.css';
import MobileSegmentFlat from './components/MobileSegmentInfo/MobileSegmentFlat/MobileSegmentFlat.css';
import MobileFlight from './components/MobileFlight/Flight.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import OrderStatus from './components/OrderCard/OrderStatus/OrderStatus.css';
import PaymentStatus from './components/OrderCard/PaymentStatus/PaymentStatus.css';
import PaymentForm from './components/PaymentForm/PaymentForm.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import OrderPassengers from './components/OrderCard/OrderPassengers/OrderPassengers.css';
import CommonItem from './components/OrderCard/CommonItem/CommonItem.css';
import OrderPreview from './components/OrderCard/OrderPreview/OrderPreview.css';
import OrderTickets from './components/OrderCard/OrderTickets/OrderTickets.css';
import OrderCardControls from './components/OrderCard/OrderCardControls/OrderCardControls.css';
import Passenger from './components/Passenger/Passenger.css';
import PassengersModal from './components/OrderCard/OrderPassengers/PassengersModal/PassengersModal.css';
import BaggageService2 from './components/BaggageService2/BaggageService2.css';
import BaggageHeader from './components/Baggage/UpgradeBaggageDialog/BaggageHeader/BaggageHeader.css';
import Checkout from './components/Checkout/Checkout.css';
import CheckinInitial from './components/Modules/Checkin/Initial/Initial.css';
import RetrieveBooking from './components/RetrieveBooking/RetrieveBooking.css';
import Contacts from './components/Contacts/Contacts.css';
import Input from './components/Input/Input.css';
import Switch from './components/Passenger/Field/Switch/Switch.css';
import PassenderFormHeader from './components/PassengerForm/Header/Header.css';
import LoyaltyGroup from './components/PassengerForm/FormFields/Group/LoyaltyGroup/LoyaltyGroup.css';
import Group from './components/PassengerForm/FormFields/Group/Group.css';
import PassengerForm from './components/PassengerForm/PassengerForm.css';
import PassengersToolbar from './components/Checkout/Form/PassengersToolbar/PassengersToolbar.css';
import PopupWrapper from './components/PassengerForm/PopupWrapper/PopupWrapper.css';
import PassengerSelect from './components/Passenger/Field/Select/Select.css';
import PassengersDetail from './components/Checkout/PassengersDetails/PassengersDetails.css';
import CheckinRules from './components/CheckinRules/CheckinRules.css';
import CheckinPassengers from './components/Modules/Checkin/Order/Passengers/Passengers.css';
import SegmentCommon from './components/Segment/SegmentCommon/SegmentCommon.css';
import SelectablePassenger from './components/SelectedPassenger/SelectedPassenger.css';
import AddPassenger from './components/AddPassenger/AddPassenger.css';
import MobileSegment from './components/MobileSegment/MobileSegment.css';
import StatusMessage from './components/StatusMessage/StatusMessage.css';
import RegisteredPassenger from './components/RegisteredPassenger/RegisteredPassenger.css';
import SendToEmail from './components/RegisteredPassenger/SendToEmail/SendToEmail.css';
import DesktopFlightModalContent from './components/DesktopFlightModalContent/DesktopFlightModalContent.css';
import Checkin from './components/Checkin/Checkin.css';
import Modal from './components/Modal/Modal.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import MobileSelectedFare from './components/MobileSelectedFare/MobileSelectedFare.css';
import PromoCodeForm from './components/PromoCode/Form/PromoCodeForm.css';
import PromoCode from './components/PromoCode/PromoCode.css';
import BaggageCard from './components/Baggage/BaggageCard.css';
import PriceGraph from './components/PriceGraph/PriceGraph.css';
import DescriptionBlock from './components/FareLock/DescriptionBlock/DescriptionBlock.css';
import Passengers from './components/Checkout/Form/Passengers/Passengers.css';
import AdditionalServiceBanner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import SuggestionModalContent from './components/SuggestionModalContent/SuggestionModalContent.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import BaggageService from './components/BaggageService/BaggageService.css';
import BaggagePassenger from './components/Baggage/UpgradeBaggageDialog/BaggagePassenger/BaggagePassenger.css';
import FormsField from './components/Forms/Field/Field.css';
import FormsBooking from './components/Forms/Booking/Booking.css';
import LocationAutocompleteGroup from './components/LocationAutocomplete/Group/Group.css';
import Forms from './components/Forms/Forms.css';
import Cart from './components/Cart/Cart.css';
import Stepbar from './components/Stepbar/Stepbar.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import MetasearchLoader from './components/MetasearchLoader/MetasearchLoader.css';
import AircraftPopup from './components/AircraftPopup/AircraftPopup.css';
import StayLoggedIn from './components/StayLoggedIn/StayLoggedIn.css';
import BaggagePage from './components/BaggagePage/BaggagePage.css';
import AdditionalServices from './components/AdditionalServices/AdditionalServices.css';
import CardExtra from './components/CardExtra/CardExtra.css';
const theme = {
    Insurance: {
        MobileScreenStyles: {
            header: Checkin.mobileScreen__header,
            close: Checkin.mobileScreen__header__closeIcon
        },
        InsuranceCardStyles: {
            insurance: Checkin.insuranceCard,
            selected: Checkin.insuranceCard_selected,
            insurance__button: Checkin.insuranceCard__button,
            insurance__button_selected: Checkin.insuranceCard__button_selected,
            insurance__money: Checkin.insuranceCard__money,
            options: Checkin.insuranceCard__options,
            insurance__header: Checkin.insuranceCard__header,
            option: Checkin.insuranceCard__option
        }
    },
    FlightCard: {
        FlightCard: {
            info: FlightCard.info,
            aircraft__nameTitle: FlightCard.aircraft__nameTitle
        }
    },
    FareGroup: {
        FareGroup: {
            fareGroup: DesktopFlightModalContent.fareGroup,
            option: DesktopFlightModalContent.option,
            option_unavailable: DesktopFlightModalContent.option_unavailable,
            option__value: DesktopFlightModalContent.value,
            option__title: DesktopFlightModalContent.title,
            options: DesktopFlightModalContent.options
        },
        FareGroupGrid: {
            upgradeOffer: DesktopFlightModalContent.fareGroup__upgradeOffer,
            paid: DesktopFlightModalContent.option_paid,
            container: DesktopFlightModalContent.container,
            option: DesktopFlightModalContent.option,
            icon: DesktopFlightModalContent.typeIcon
        }
    },
    PaymentForm: {
        PaymentForm: {
            content__title__back: PaymentForm.content__title__back
        }
    },
    DesktopFlight: {
        DesktopFlightPopup: {},
        ModalContent: {
            paper: DesktopFlightModalContent.modalPaper,
            fareGroup_stub: DesktopFlightModalContent.fareGroup_stub,
            buttons: DesktopFlightModalContent.buttons,
            fareGroup__button_active: DesktopFlightModalContent.active
        }
    },
    Button: {
        Button: {
            button: Button.button
        },
        ActionButton: {
            button: Button.actionButton,
            button_small: Button.actionButton
        }
    },
    Counter: {
        Counter: {
            button: Counter.button
        }
    },
    Autocomplete: {
        Autocomplete: {
            group__label: LocationAutocomplete.group__label,
            input_focused: cn(Input.input_focused),
            label_shrink: Input.label_shrink
        }
    },
    SearchFormDatepicker: {
        DayStyles: {
            day_withPrice: SearchFormDatepicker.day_withPrice,
            day_selected: SearchFormDatepicker.day_selected
        },
        MonthHeaderStyles: {
            monthHeader: SearchFormDatepicker.monthHeader,
            monthHeader__select_month: SearchFormDatepicker.month,
            monthHeader__select_year: SearchFormDatepicker.year
        },
        MonthsWrapperStyles: {
            nav_next: MonthWrapper.monthWrapper__nav_next,
            nav_prev: MonthWrapper.monthWrapperrapper__nav_prev
        },
        WeeklyHeaderStyles: {
            day: SearchFormDatepicker.weekly__day
        },
        SearchFormDatepickerStyles: {
            content: SearchFormDatepicker.content,
            footer: SearchFormDatepicker.footer
        }
    },
    Passengers: {
        PassengerStyles: {
            increase: Passenger.increase,
            decrease: Passenger.decrease,
            info__icon: Passenger.info__icon,
            age: Passenger.age
        }
    },
    SearchForm: {
        Datepicker: {
            dates__to: SearchForm.date_to,
            dates__back: SearchForm.date_back,
            dates__to_focused: SearchForm.date__to_focused,
            dates__back_focused: SearchForm.date__back_focused,
            dates_focused: SearchForm.dates_focused
        },
        PromoCode: {
            promoCode: QuickSearchForm.quickSearchForm__form__promocode
        },
        PayByMiles: {
            switchBox: QuickSearchForm.quickSearchForm__form__payByMiles
        },
        MultiCity: {
            caption: QuickSearchForm.quickSearchForm__form__multiCity
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            form: QuickSearchForm.quickSearchForm__form,
            wrapper: QuickSearchForm.quickSearchForm__form_wrapper,
            form__wrapper: QuickSearchForm.quickSearchForm__form_wrapper,
            outer__summary: QuickSearchForm.outer__summary
        },
        Summary: {
            route: QuickSearchForm.summary__route,
            dates: QuickSearchForm.summary__dates
        }
    },
    Toolbar: {
        Toolbar: {
            button: Toolbar.button,
            inner: Toolbar.inner,
            backButton: Toolbar.backButton
        }
    },
    Results: {
        Results: {
            results: Results.results,
            share: Results.results__share,
            inner: Results.results__inner,
            toolbar__backButton: Results.backButton
        },
        Calendar: {
            title: Results.calendar__title,
            legNumber: Results.legNumber,
            diagram: Results.calendar__diagram
        },
        DummyWeekCalendar: {
            wrapper: WeekCalendar.dummyWrapper
        },
        OtherDates: {
            container: Results.otherDates,
            text: Results.otherDates__text
        }
    },
    WeekCalendar: {
        DayStyles: {
            day: WeekCalendar.day,
            date: WeekCalendar.date,
            date__dow: WeekCalendar.dow,
            day_selected: WeekCalendar.day_selected,
            price: WeekCalendar.price,
            date__info: WeekCalendar.date__info
        },
        WeekCalendarStyles: {
            dayWrapper: WeekCalendar.day__wrapper
        },
        SliderStyles: {
            arrow: WeekCalendar.arrow
        }
    },
    SeatMap: SeatStyles,
    SegmentTabs: {
        SegmentTab: {
            segment: SegmentTab.tab,
            segment_active: SegmentTab.active
        },
        SegmentTabs: {
            title: SegmentTab.title
        }
    },
    Meal: {
        Meal: {
            meal: Meal.meal,
            image: Meal.image,
            name: Meal.name,
            price: Meal.price,
            meal_fullSize: Meal.fullscreen,
            count: Meal.count
        },
        Details: {
            image: Meal.details__image,
            name: Meal.details__name,
            price: Meal.details__price,
            counter: Meal.details__counter,
            passenger: Meal.details__passenger,
            passenger__index: Meal.details__passengerIndex,
            description: Meal.details__description
        }
    },
    FareLock: {
        DescriptionBlock: {
            icon: DescriptionBlock.icon
        }
    },
    MealService: {
        List: {
            item: Meal.mealCategory,
            item_selected: Meal.mealCategory__selected
        },
        ServiceWrapper: {
            meals: Meal.meals
        }
    },
    DesktopFlightRoute: {
        DesktopFlightRouteStyles: {
            flight: DesktopFlightRoute.flight
        },
        SegmentStyles: {
            route: Segment.segment__route,
            plane: Segment.segment__plane,
            flightInfo__date: Segment.flightInfo__date,
            flightInfo__airline: Segment.flightInfo__airline,
            planeInfo: Segment.planeInfo,
            planeContainer: Segment.planeContainer,
            totalDuration: Segment.totalDuration
        },
        PointStyles: {
            time: Point.time,
            mobile: Point.mobile,
            point_thin: Point.point_thin,
            airport: Point.airport
        },
        RouteArrowStyles: {
            timeInRoute: RouteArrow.timeInRoute,
            flightNumber: RouteArrow.flightNumber
        },
        FlightPriceStyles: {
            selectFrom_best: FlightPrice.selectFrom_best,
            button: FlightPrice.button,
            currency: FlightPrice.currency,
            clear: FlightPrice.clear,
            fare_family: FlightPrice.fare_family,
            price: FlightPrice.price,
            price_selected: FlightPrice.price_selected,
            price__money: FlightPrice.price__money
        },
        StopsInfoStyles: {
            stop: StopsInfo.stop
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Amenities.amenities__item,
            amenities__item_unavailable: Amenities.amenities__item_unavailable
        }
    },
    MobileSegmentInfo: {
        MobileSegmentFlat: {
            aircraft__details: MobileSegmentFlat.aircraft__details
        }
    },
    MobileFlight: {
        FlightStyles: {
            price: MobileFlight.price,
            price__money: MobileFlight.price__money,
            currency: MobileFlight.currency,
            flight: MobileFlight.flight,
            stopPoint: MobileFlight.stopPoint
        }
    },
    OrderCard: {
        OrderCard: {
            root: OrderCard.root,
            container: OrderCard.container,
            type_review: OrderCard.type_review,
            preview: OrderCard.preview
        },
        PaymentStatus: {
            root: PaymentStatus.root,
            icon: PaymentStatus.icon
        },
        OrderBooking: {
            root: OrderBooking.root,
            type_review: OrderBooking.type_review,
            orderCode: OrderBooking.orderCode,
            icon: OrderBooking.icon,
            price: OrderBooking.price,
            security_code: OrderBooking.security_code
        },
        OrderPassengers: {
            root: OrderPassengers.root,
            control: OrderPassengers.control,
            icon: OrderPassengers.icon
        },
        CommonItem: {
            root: CommonItem.root,
            review: CommonItem.review,
            buttons: CommonItem.buttons,
            icon: CommonItem.icon
        },
        OrderStatus: {
            icon: OrderStatus.icon,
            transactions: OrderStatus.transactions
        },
        OrderPreview: {
            city: OrderPreview.city,
            main_city: OrderPreview.main_city
        },
        OrderTickets: {
            wrapper: OrderTickets.wrapper,
            icon: OrderTickets.icon
        },
        OrderCardControls: {
            icon: OrderCardControls.icon,
            button: OrderCardControls.button
        },
        PassengersModal: {
            passengers_wrapper: PassengersModal.passengers_wrapper
        },
        OrderChange: {
            icon: CommonItem.orderChange_icon
        }
    },
    Passenger: {
        PassengerStyles: {
            form__field: Passenger.form__field,
            form_citizenship: Passenger.form_citizenship,
            form_contacts: Passenger.form_contacts
        },
        Switch: {
            container: Switch.container,
            element: Switch.element,
            element_active: Switch.element_active,
            element_error: Switch.element_error,
            error: Switch.error
        },
        Select: {
            helperText: PassengerSelect.helperText,
            input: Input.select_input,
            label: Input.select_label,
            icon: Input.select_icon,
            real_input: Input.select_real_input
        }
    },
    SocialAuth: {
        SocialAuth: {
            button: SocialAuth.button,
            button_facebook: SocialAuth.button_facebook,
            button_google: SocialAuth.button_google
        }
    },
    IncludedBaggage: {
        IncludedBaggage: {
            footer: BaggageService2.includedBaggage__footer,
            root: BaggageService2.includedBaggage__root,
            fare_family: BaggageService2.includedBaggage__fareFamily,
            header: BaggageService2.includedBaggage__header
        }
    },
    BaggageTotalPriceBlock: {
        BaggageTotalPriceBlock: {
            control: BaggageService2.baggageTotalPriceBlock__control
        }
    },
    AdditionalBaggage: {
        AdditionalModal: {
            root: BaggageService2.additionalBaggage__modal,
            modal__paper: BaggageService2.additionalModal__paper
        },
        AdditionalModalHeaderDesktop: {
            promo: BaggageService2.additionalHeaderDesktop__promo,
            price_wrapper: BaggageService2.additionalModalHeader__priceWrp
        },
        AdditionalBaggage: {
            footer: BaggageService2.additionalBaggage__footer,
            root: BaggageService2.additionalBaggage__root,
            header: BaggageService2.additionalBaggage__header,
            promo_message: BaggageService2.additionalBaggage__promoMessage
        }
    },
    Baggage: {
        Baggage: {
            root: BaggageService2.baggage__root,
            selected: BaggageService2.baggage_selected
        },
        BaggageIcon: {
            root: BaggageService2.baggageIcon__root,
            size: BaggageService2.baggageIcon__size,
            carry_on: BaggageService2.baggageIcon_carryOn,
            checked_baggage: BaggageService2.baggageIcon_checkedBaggage,
            small: BaggageService2.baggageIcon_small,
            middle: BaggageService2.baggageIcon_medium,
            large: BaggageService2.baggageIcon_large,
            wrapper: BaggageService2.baggageIcon_wrapper
        }
    },
    BaggageService2: {
        Trigger: {
            trigger: BaggageService2.trigger,
            servicePreview: BaggageService2.trigger__servicePreview
        },
        SportEquipmentHeader: {
            size: BaggageService2.sportEquipmentHeader__size,
            price: BaggageService2.sportEquipmentHeader__price
        },
        OverweightHeader: {
            service: BaggageService2.overweightHeader__service
        },
        BaggageModal: {
            content: BaggageService2.baggageModal__content
        },
        BaggageServiceStyles: {}
    },
    BaggageList: {
        BaggageList: {
            baggage_count: BaggageService2.baggageList__count,
            item: BaggageService2.baggageList__item,
            scrollable: BaggageService2.scrollable
        }
    },
    AdditionalServices: {
        Insurance: {
            paper: AdditionalServices.paper
        }
    },
    CardExtra: {
        CardExtraContent: {
            root: CardExtra.root,
            root_seats: CardExtra.root_seats,
            root_baggage: CardExtra.root_baggage,
            root_meal: CardExtra.root_meal,
            root_insurance: CardExtra.root_insurance,
            header: CardExtra.header,
            header__title: CardExtra.header__title,
            header__icon: CardExtra.header__icon,
            footer: CardExtra.footer,
            button_add: CardExtra.button_add,
            button_change: CardExtra.button_change
        }
    },
    Checkout: {
        PassengersToolbar: {
            root: PassengersToolbar.root,
            checkbox: PassengersToolbar.checkbox
        },
        CheckoutStyles: {
            desktopFlight__flight: Checkout.checkout__desktopFlight,
            checkoutServices: Checkout.additionalServicesWrapper,
            checkout: Checkout.checkout,
            container: Checkout.container
        },
        PassengersStyles: {
            passengers: Passengers.passengers
        }
    },
    AdditionalServiceBanner: {
        AdditionalServiceBannerStyles: {
            extrasBanner: Checkin.additionalExtrasBanner,
            baggageBanner: AdditionalServiceBanner.baggageBanner,
            image: AdditionalServiceBanner.image,
            wrapper: BaggageService2.additionalService__banner
        }
    },
    Checkin: {
        Inital: {
            wrapper: CheckinInitial.wrapper,
            form: CheckinInitial.form,
            hint: CheckinInitial.hint,
            hint__title: CheckinInitial.hint__title,
            hint__image: CheckinInitial.hint__image,
            hint__info: CheckinInitial.hint__info,
            hint__info__text: CheckinInitial.hint__info__text,
            hint__info__icon: CheckinInitial.hint__info__icon
        },
        Passengers: {
            title: CheckinPassengers.title,
            timelimit__icon: CheckinPassengers.timelimit__icon,
            toolbar__button: CheckinPassengers.toolbar__button,
            passengers: CheckinPassengers.passengers,
            segments: CheckinPassengers.segments,
            segment: CheckinPassengers.segment,
            toolbar: CheckinPassengers.toolbar
        }
    },
    RetrieveBooking: {
        RetrieveBooking: {
            title: RetrieveBooking.title,
            form__row: RetrieveBooking.form__row
        }
    },
    Contacts: {
        ContactsStyles: {
            footer__inner: Contacts.contactsFooter__inner,
            description__header: Contacts.description__header,
            description__text: Contacts.description__text,
            contacts: Contacts.contacts,
            header: Contacts.header,
            form__container: Contacts.form__container,
            footer: Contacts.footer,
            footer__timerIcon: Contacts.footer__timerIcon
        },
        ResendStyles: {
            item: Contacts.item
        }
    },
    Input: {
        Input: {
            textField__root: Input.textField__root,
            textField_filled: Input.textField_filled,
            textField_focused: Input.textField_focused,
            input_focused: cn(Input.input_focused, PromoCodeForm.input__focused),
            input_error: Input.input_error,
            input_filled: Input.input_filled,
            real_input: cn(Input.real_input, PromoCodeForm.realInput),
            input: cn(Input.input, PromoCodeForm.input),
            label_shrink: Input.label_shrink,
            hint_error: Input.hint_error,
            root: cn(Input.root, PromoCodeForm.rootInput)
        }
    },
    LoginPage: {
        StayLoggedIn: {
            rememberMe: StayLoggedIn.rememberMe
        },
        RegistrationForm: {
            root: Contacts.registrationForm__root
        },
        CodeForm: {
            root: Contacts.registrationForm__root
        }
    },
    PassengerForm: {
        PassengerForm: {
            form: PassengerForm.form
        },
        Group: {
            container: Passenger.group__container,
            field_birthdate: Group.field_birthdate
        },
        Header: {
            number: PassenderFormHeader.number,
            header: PassenderFormHeader.header,
            filled: PassenderFormHeader.filled,
            passengerName: PassenderFormHeader.passengerName
        },
        LoyaltyGroup: {
            toggle: LoyaltyGroup.toggle,
            loyalty_switch_open: LoyaltyGroup.loyalty_switch_open,
            switch__label: LoyaltyGroup.switch__label,
            loyalty__desc: LoyaltyGroup.loyalty__desc
        },
        PopupWrapper: {
            confirm: PopupWrapper.confirm,
            cancel: PopupWrapper.cancel,
            disabled: PopupWrapper.disabled
        }
    },
    CheckinRules: {
        CheckinRules: {
            rules__title: CheckinRules.rules__title,
            rules__text: CheckinRules.rules__text,
            rules__label: CheckinRules.rules__label,
            rules__checkbox: CheckinRules.rules__checkbox
        }
    },
    Segment: {
        SegmentCommon: {
            wrapper: SegmentCommon.wrapper,
            header_withWeather: SegmentCommon.header_withWeather,
            flightInfo: SegmentCommon.flightInfo,
            flightInfo__item: SegmentCommon.flightInfo__item,
            flightInfo__title: SegmentCommon.flightInfo__title,
            flightInfo__value: SegmentCommon.flightInfo__value,
            city__airport: SegmentCommon.city__airport,
            city__info: SegmentCommon.city__info,
            city__iata: SegmentCommon.city__iata,
            city__time: SegmentCommon.city__time,
            airline__name: SegmentCommon.airline__name,
            plane__icon: SegmentCommon.plane__icon
        }
    },
    Switch: {
        Switch: {
            wrapper: BaggageService2.additionalCheckbox__wrapper
        }
    },
    SelectedPassenger: {
        SelectedPassenger: {
            loyalty__link: Checkin.selectedPassenger__loyaltyLink,
            wrapper: SelectablePassenger.wrapper,
            passenger__icon: SelectablePassenger.passenger__icon,
            passenger__name: SelectablePassenger.passenger__name,
            passengerInfo: SelectablePassenger.passengerInfo,
            passengerInfo__item: SelectablePassenger.passengerInfo__item,
            passengerInfo__field: SelectablePassenger.passengerInfo__field,
            rightSide: SelectablePassenger.rightSide
        }
    },
    AddPassenger: {
        AddPassenger: {
            wrapper: AddPassenger.wrapper,
            addButton: AddPassenger.addButton,
            addButton__icon: AddPassenger.addButton__icon,
            passengerIcon: AddPassenger.passengerIcon,
            form: AddPassenger.form,
            submitButton: AddPassenger.submitButton,
            submitButton_loader: AddPassenger.submitButton_loader,
            submitButton_success: AddPassenger.submitButton_success,
            form__input: AddPassenger.form__input,
            form__wrapper: AddPassenger.form__wrapper
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: MobileSegment.wrapper,
            flightInfo: MobileSegment.flightInfo,
            flightInfo__iatas: MobileSegment.flightInfo__iatas,
            flightInfo__cities: MobileSegment.flightInfo__cities,
            flightInfo__time: MobileSegment.flightInfo__time,
            planeIcon: MobileSegment.planeIcon,
            fareGroup: MobileSegment.fareGroup,
            fareGroup__info: MobileSegment.fareGroup__info,
            flightNumber: MobileSegment.flightNumber,
            arrivalInfo: MobileSegment.arrivalInfo,
            arrivalInfo__title: MobileSegment.arrivalInfo__title,
            arrivalInfo__item: MobileSegment.arrivalInfo__item
        }
    },
    StatusMessage: {
        StatusMessage: {
            statusMessage: StatusMessage.statusMessage,
            statusMessage_success: StatusMessage.statusMessage_success,
            statusMessage__title: StatusMessage.statusMessage__title,
            statusMessage__text: StatusMessage.statusMessage__text
        }
    },
    RegisteredPassenger: {
        RegisteredPassenger: {
            wrapper: RegisteredPassenger.wrapper,
            header: RegisteredPassenger.header,
            passenger: RegisteredPassenger.passenger,
            seats__icon: RegisteredPassenger.seats__icon,
            seats: RegisteredPassenger.seats,
            downloadButton: RegisteredPassenger.downloadButton,
            downloadIcon: RegisteredPassenger.downloadIcon,
            footerActions: RegisteredPassenger.footerActions,
            footerActions__cancel: RegisteredPassenger.footerActions__cancel,
            actions__buttons: RegisteredPassenger.registeredPassenger_actionsButtons,
            sendToEmail: RegisteredPassenger.registeredPassenger_sendToEmail,
            appleWallet: RegisteredPassenger.registeredPassenger_appleWallet
        },
        SendToEmail: {
            wrapper: SendToEmail.wrapper,
            text: SendToEmail.text
        }
    },
    FullscreenDialog: {
        FullscreenDialog: {
            close__text: Modal.fullscreenDialog__closeText,
            close__icon: Modal.fullscreenDialog__closeIcon
        }
    },
    PassengersDetails: {
        Passenger: {
            passenger: PassengersDetail.passenger,
            number: PassengersDetail.number,
            filled: PassengersDetail.filled,
            name: PassengersDetail.name,
            content: PassengersDetail.content
        },
        Details: {
            slideBottom__container: PassengersDetail.slideBottom__container
        }
    },
    Modal: {
        Modal: {
            modal: Modal.modal,
            scrollBody: Modal.scrollBody,
            closeIcon: cn(Modal.closeIcon, PromoCode.closeIcon),
            modal_rounded: Modal.modal_rounded
        }
    },
    CompareFares: {
        CompareFares: {
            image: FareConditions.compareFare__image,
            content: FareConditions.compareFares__content,
            slider: FareConditions.slider
        }
    },
    FareConditions: {
        FareConditions: {
            paperRoot: FareConditions.paperRoot,
            header: FareConditions.header,
            heading: FareConditions.heading,
            tabsWrp: FareConditions.tabsWrp,
            tab: FareConditions.tab,
            tab_active: FareConditions.tab_active,
            tabIndicator: FareConditions.tabIndicator,
            fareConditionsSegmentHeading__inner: FareConditions.fareConditionsSegmentHeading__inner,
            fareConditionsSegmentFareCode: FareConditions.fareConditionsSegmentFareCode,
            fareConditionsContent: FareConditions.fareConditionsContent,
            segmentTabs: FareConditions.segmentTabs
        }
    },
    MobileSelectedFare: {
        MobileSelectedFareStyles: {
            dialog__header: MobileSelectedFare.dialog__header,
            dialog__content: MobileSelectedFare.dialog__content,
            feature__icon: MobileSelectedFare.feature__icon,
            features__info: MobileSelectedFare.features__info
        }
    },
    PromoCode: {
        PromoCodeForm: {
            form: PromoCodeForm.form,
            statusMessage: PromoCodeForm.statusMessage,
            button: PromoCodeForm.button
        },
        PromoCode: {
            modal: PromoCode.modal,
            clear: QuickSearchForm.quickSearchForm__form__promocodeClear
        }
    },
    BaggageCard: {
        BaggageCard: {
            wrapper: BaggageCard.wrapper,
            button: BaggageCard.button,
            price: BaggageCard.price
        }
    },
    UpgradeBaggageDialog: {
        BaggageDialogHeader: {
            baggage__container: BaggageHeader.container,
            info: BaggageHeader.info
        },
        MobileBaggageSelector: {
            description: BaggageHeader.description
        },
        BaggagePassenger: {
            name_wrapper: BaggagePassenger.name_wrapper
        },
        BaggageSegment: {
            name_withPrices: BaggagePassenger.name_withPrices,
            prices: BaggagePassenger.prices
        },
        HeaderEquipmentItem: {
            selected: BaggageHeader.selected,
            wrapper: BaggageHeader.headerEquipWrapper,
            active: BaggageHeader.active
        }
    },
    PriceGraph: {
        PriceGraphStyles: {
            header: PriceGraph.header,
            routeType: PriceGraph.routeType
        },
        MonthsListStyles: {
            currentMonth: PriceGraph.currentMonth,
            currentMonth__monthName: PriceGraph.currentMonth__monthName,
            currentMonth__year: PriceGraph.currentMonth__year
        },
        LegendsStyles: {
            label: PriceGraph.legents__label,
            line_max: PriceGraph.legents__line_max,
            line_min: PriceGraph.legents__line_min,
            money: PriceGraph.legents__money
        },
        DayStyles: {
            progress: PriceGraph.day__progress,
            minPrice: PriceGraph.day__number,
            number: PriceGraph.day__number,
            tooltip__date: PriceGraph.day__tooltip__date
        }
    },
    SuggestionModalContent: {
        SuggestionModalContent: {
            modal__content: SuggestionModalContent.modal__content
        }
    },
    PromoLoader: {
        PromoLoader: {
            promo__image: PromoLoader.promo__image,
            promo__content: PromoLoader.promo__content
        }
    },
    BaggageService: {
        BaggageServiceStyles: {
            service: BaggageService.service,
            services__switcher: BaggageService.services__switcher,
            segment__direction: BaggageService.segment__direction,
            pet: BaggageService.pet
        }
    },
    Forms: {
        Forms: {
            tab: Forms.tab
        },
        Booking: {
            submit: FormsBooking.submit
        },
        Field: {
            label: FormsField.label,
            label_shrink: FormsField.label_shrink,
            input__inner: FormsField.input__inner,
            label_error: FormsField.label_error,
            label_filled: FormsField.label_filled,
            input__wrapper: FormsField.input__wrapper
        }
    },
    LocationAutocomplete: {
        Group: {
            group: LocationAutocompleteGroup.group,
            group__label: LocationAutocompleteGroup.group__label
        }
    },
    ServiceSummary: {
        ServiceSummary: {
            header__title: Cart.header__title,
            header__price: Cart.header__price,
            header__icon: Cart.header__icon,
            header__number: Cart.header__number
        },
        ServiceSummaryOption: {
            option__price_money: Cart.option__price__money,
            option__included: Cart.option__included
        }
    },
    Stepbar: {
        Step: {
            step: Stepbar.step,
            step_active: Stepbar.step_active,
            step_disabled: Stepbar.step_disabled
        }
    },
    MobileStepbar: {
        StepContentStyles: {
            content__icon: Stepbar.content__icon
        }
    },
    MetasearchLoader: {
        MetasearchLoader: {
            logo: MetasearchLoader.logo
        }
    },
    AircraftPopup: {
        AircraftPopupContent: {
            slider: AircraftPopup.aircraftPopupContent__slider
        },
        AircraftPopup: {
            close: AircraftPopup.close
        }
    },
    BaggagePage: {
        BaggagePage: {
            baggage: BaggagePage.baggage
        }
    }
};
export default theme;
